// extracted by mini-css-extract-plugin
module.exports = {"btn":"naver_btn__1Ghad","fake":"naver_fake__1lxZc"};